import React from 'react';

import { usePetitionActionsPageState } from '#src/app/pages/actions/pageContext';

import { AddSupporterVoice } from '../AddSupporterVoice';
import { SupporterVoices } from '../SupporterVoices';
import { CaptureVideo } from '../Videos';

export const Actions: React.FC = () => {
	const [{ shouldDisplaySupporterVoicesVideo }] = usePetitionActionsPageState();

	return (
		<>
			{shouldDisplaySupporterVoicesVideo ? (
				<CaptureVideo />
			) : (
				<>
					<AddSupporterVoice />
					<SupporterVoices />
				</>
			)}
		</>
	);
};
